import { useEffect, useState } from 'react';
import useMobileApp from '../mobile-app/useMobileApp';

interface Props {
  onScroll?: (scrollPosition: number) => void;
}

const useScrollPosition = (props?: Props) => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [scrolling, setScrolling] = useState(false);
  const { isMobileApp } = useMobileApp();

  let removed = false;
  let handle = null;

  useEffect(() => {
    const updatePosition = () => {
      setScrollPosition(window.pageYOffset);
      props?.onScroll && props?.onScroll(window.pageYOffset);

      if (handle) {
        clearTimeout(handle);
        setScrolling(true);
      }

      handle = setTimeout(() => setScrolling(false), 100);
    };
    const abortController = new AbortController();
    const eventName = isMobileApp ? 'ionScroll' : 'scroll';

    window.addEventListener(eventName, updatePosition, { signal: abortController.signal });

    updatePosition();

    return () => {
      abortController.abort();

      if (removed) {
        return;
      }

      removed = true;
      if (handle) {
        clearTimeout(handle);
      }
    };
  }, [isMobileApp, props?.onScroll]);

  return { scrollPosition, scrolling };
};

export default useScrollPosition;
